"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.legend45DegreeLine = exports.legendResult = exports.legendValidation = exports.legendNoModel = exports.legend = exports.chartContainer = exports.legendText = exports.barAxisLabel = exports.barAxisLabelContainer = exports.barAxisText = exports.barStatusText = void 0;
var typestyle_1 = require("typestyle");
require("@tableau/fonts-tableau");
var colors = require("../util/colors");
var textCommon = {
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0.2px',
    color: colors.tableauGray11,
};
exports.barStatusText = typestyle_1.style(__assign(__assign({}, textCommon), { fontWeight: 500 }));
exports.barAxisText = typestyle_1.style(__assign(__assign({}, textCommon), { fontWeight: 400 }));
exports.barAxisLabelContainer = typestyle_1.style({
    height: '100%',
});
exports.barAxisLabel = typestyle_1.style(__assign(__assign({}, textCommon), { fontWeight: 400, display: 'inline-block', width: '38px', height: '100%', overflow: 'hidden', textAlign: 'center', textDecoration: 'none', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }));
exports.legendText = typestyle_1.style(__assign(__assign({}, textCommon), { fontWeight: 350, marginLeft: '8px' }));
exports.chartContainer = typestyle_1.style({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});
exports.legend = typestyle_1.style({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
});
exports.legendNoModel = typestyle_1.style({
    width: '24px',
    height: '2px',
    backgroundColor: colors.black,
    opacity: 0.29,
});
exports.legendValidation = typestyle_1.style({
    width: '24px',
    height: '2px',
    backgroundColor: colors.textLinkDefault,
    marginLeft: '16px',
});
exports.legendResult = typestyle_1.style({
    width: '12px',
    height: '12px',
    backgroundColor: colors.textLinkDefault,
    borderRadius: '50%',
});
exports.legend45DegreeLine = typestyle_1.style({
    width: '24px',
    height: '2px',
    backgroundColor: colors.black,
    marginLeft: '16px',
});
//# sourceMappingURL=ChartStyles.js.map